import { useEffect, useState } from "react";
import { X, FileText } from "lucide-react";
import { api, errMsg, formatTime, formatIDR } from "@/lib/api";

export function ProofViewer({ payout, endpoint, onClose }) {
  const [url, setUrl] = useState(null);
  const [type, setType] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    let objectUrl;
    api.get(endpoint, { responseType: "blob" })
      .then((r) => { objectUrl = URL.createObjectURL(r.data); setType(r.data.type); setUrl(objectUrl); })
      .catch(async (e) => {
        const text = e.response?.data instanceof Blob ? JSON.parse(await e.response.data.text())?.detail : errMsg(e);
        setError(text || "Gagal memuat bukti transfer");
      });
    return () => { if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [endpoint]);

  return (
    <div className="fixed inset-0 z-50 bg-slate-900/60 flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-card rounded-xl w-full max-w-2xl max-h-[90vh] flex flex-col" onClick={(e) => e.stopPropagation()} data-testid="proof-viewer">
        <div className="flex items-center justify-between px-5 py-4 border-b border-border">
          <div><p className="font-heading font-medium text-slate-800">Bukti transfer · {formatIDR(payout.amount)}</p><p className="text-xs text-slate-500">{formatTime(payout.created_at)}{payout.talent_name ? ` · ${payout.talent_name}` : ""}{payout.note ? ` · ${payout.note}` : ""}</p></div>
          <button className="p-2 rounded-lg hover:bg-secondary" onClick={onClose} data-testid="proof-viewer-close" aria-label="Tutup"><X size={18} strokeWidth={1.5} /></button>
        </div>
        <div className="p-5 overflow-auto flex-1 flex items-center justify-center min-h-[240px]">
          {error && <p className="text-sm text-rose-700" data-testid="proof-viewer-error">{error}</p>}
          {!error && !url && <p className="text-sm text-slate-500">Memuat bukti...</p>}
          {url && type.startsWith("image/") && <img src={url} alt="Bukti transfer" className="max-w-full max-h-[70vh] rounded-lg border border-border" data-testid="proof-viewer-image" />}
          {url && type === "application/pdf" && (
            <div className="text-center"><FileText size={40} strokeWidth={1.5} className="mx-auto text-slate-400" /><a href={url} target="_blank" rel="noreferrer" className="btn-outline mt-4" data-testid="proof-viewer-pdf-link">Buka PDF</a></div>
          )}
        </div>
      </div>
    </div>
  );
}
